import React from 'react';
import { Textarea as OriginalTextarea } from '@fiverr-private/forms';
import { useParentPropsOverrideContext } from '@fiverr-private/ui_utils';

const Textarea = (props) => {
    const context = useParentPropsOverrideContext();

    return <OriginalTextarea {...props} {...context} />;
};

export default Textarea;
